// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-right .member-container[data-v-5a75e449]{align-items:flex-end}.member-container[data-v-5a75e449]:before{display:block;width:100%;height:1px;background:#000;content:\"\";position:absolute;top:2rem;left:0}.member-container .text-container[data-v-5a75e449]{max-width:430px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
